import { useEffect, useRef } from "react";

export function useEffectNotOnMount(cb: Function, deps: any[]) {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      cb();
    } else {
      isMounted.current = true;
    }
  }, deps);
}
